import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import { GeneralTab } from './GeneralTab';
import { ByGradeTab } from './ByGradeTab';
import { BySchoolTab } from './BySchoolTab';

const TABS = [
  { value: 'geral', label: 'Geral' },
  { value: 'por-ano', label: 'Por Ano' },
  { value: 'por-unidade-escolar', label: 'Por Unidade Escolar' }
];

export function MocksFlorianoReport() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('aba') || 'geral';

  return (
    <div className="report">
      <header className="report__header">
        <h1 className="report__title">
          <button
            className="card__icon-wrapper"
            aria-label="Voltar"
            title="Voltar"
            onClick={() => navigate('/metricas/institucional')}
          >
            <FiChevronLeft className="card__icon" />
          </button>
          Relatório Simulados Floriano Educa 7
        </h1>
        <p className="report__description">Acompanhe a evolução de alunos e escolas durante os simulados</p>
      </header>

      <div className="report-tab">
        {TABS.map(tab => (
          <button
            key={tab.value}
            type="button"
            className={`report-tab__link ${activeTab === tab.value ? 'report-tab__link--is-active' : ''}`}
            onClick={() => setSearchParams({ aba: tab.value })}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="report__body">
        {activeTab === 'geral' && <GeneralTab />}
        {activeTab === 'por-ano' && <ByGradeTab />}
        {activeTab === 'por-unidade-escolar' && <BySchoolTab />}
      </div>
    </div>
  );
}
